import { render } from "./feed-customer-card.vue?vue&type=template&id=22816983&scoped=true"
import script from "./feed-customer-card.vue?vue&type=script&lang=js"
export * from "./feed-customer-card.vue?vue&type=script&lang=js"

import "./feed-customer-card.vue?vue&type=style&index=0&id=22816983&scoped=true&lang=css"

import exportComponent from "/home/runner/work/provider-frontend/provider-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22816983"]])

export default __exports__